/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckDocumentProvisionMethod {
    MANUAL = 'MANUAL',
    SCAN = 'SCAN',
    UPLOAD = 'UPLOAD'
}


export function instanceOfPaxCheckDocumentProvisionMethod(value: any): boolean {
    for (const key in PaxCheckDocumentProvisionMethod) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckDocumentProvisionMethod, key)) {
            if (PaxCheckDocumentProvisionMethod[key as keyof typeof PaxCheckDocumentProvisionMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckDocumentProvisionMethodFromJSON(json: any): PaxCheckDocumentProvisionMethod {
    return PaxCheckDocumentProvisionMethodFromJSONTyped(json, false);
}

export function PaxCheckDocumentProvisionMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentProvisionMethod {
    return json as PaxCheckDocumentProvisionMethod;
}

export function PaxCheckDocumentProvisionMethodToJSON(value?: PaxCheckDocumentProvisionMethod | null): any {
    return value as any;
}

export function PaxCheckDocumentProvisionMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckDocumentProvisionMethod {
    return value as PaxCheckDocumentProvisionMethod;
}

